import request from '@/found/utils/request';
import Form from '@/found/components/form/form.vue';

export default {
  extends: Form,
  data() {
    return {
      formFunctionCode: 'shareForm',
      buttonText: {
        submit: '审核通过',
        submitAudit: '审核驳回',
      },
      // 传true则显示该按钮
      buttons: {
        submit: true, // 点击会执行submit(btnType)函数，接收bntType为：1
        submitAudit: true, // 点击会执行submit(btnType)函数，接收bntType为：2

      },
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  created() {
  },
  methods: {
    async formComplete() {
      await this.loadData();
      console.log(this.formConfig.code);
      const approvalRule = this.getRule('approvalStatus');
      approvalRule.props.disabled = true;
      console.log(approvalRule);
    },
    async loadData() {
      if (this.formConfig.row && this.formConfig.row.id) {
        const { result } = await request.get(
          '/cps/v1/memberShareRecord/getById',
          {
            id: this.formConfig.row.id,
          },
        );
        if (!result) return;

        this.setValue({
          ...result,

        });
      }
    },
    /**
     * 设置自定义配置信息
     * @param {object} item 获取配置信息
     * @returns {object} v 返回自定义配置信息
     */
    setRule(item) {
      const v = item;
      v.props.formConfig = this.formConfig;
      v.props.fApi = this.fApi;
      return v;
    },

    /**
     * 提交表单
     */
    async submit(e) {
      console.log('submit', e);
      const formData = this.getFormData();
      if (!formData) return;
      const pointsFlag = this.validateNumber(formData.approvalPoints);
      if (e === 1) {
        formData.approvalStatus = '1';
        if (pointsFlag) {
          request.post('/cps/v1/memberShareRecord/approval', formData).then((res) => {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          });
        } else {
          this.$message.error('请输入10-50之间的数字');
        }
      }
      if (e === 2) {
        formData.approvalStatus = '2';
        request.post('/cps/v1/memberShareRecord/approval', formData).then((res) => {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.$emit('onClose');
          this.$emit('onGetList');
        });
      }
    },
    /**
     * 校验积分
     */
    validateNumber(input) {
      // 定义正则表达式，用于匹配整数或保留两位小数的数字
      const regex = /^\d+(\.\d{1,2})?$/;
      // 检查输入是否匹配正则表达式
      if (regex.test(input)) {
        const num = parseFloat(input);
        // 检查数字是否在 10 到 50 之间
        return num >= 10 && num <= 50;
      }
      return false;
    },
  },
};
